import React from 'react';
import Table from '@/components/organisms/table';
import { useRouter } from 'next/navigation';
import Pagination from '@/components/atoms/pagination';

const ActiveOrdersTable = ({ details, setCurrentPage, currentPage }: Partial<any>) => {
    const router = useRouter();

    const handleNavigate = (orderNumber: string, isCt: boolean) => {
        router.push(`/order-tracking?order=${orderNumber}&unique=true${isCt ? '&ct=true' : ''}`);
    };
    const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
    
    return (
        <>
            <Table className="">
                <Table.Container className='border-none'>
                    <Table.Head className='shadow-none'>
                        <Table.Cell className='font-semibold text-[16px] bg-white border-b border-[#CCCCCC] px-0 [&>span]:text-[16px] [&>p]:text-[16px] [&>p]:leading-6 [&>p]:font-semibold [&>span]:font-semibold [&>p]:text-[#090909] text-[#090909] [&>p]:px-1 [&>p]:text-left capitalize w-[25%]'>Sales Order ID</Table.Cell>
                        <Table.Cell className='font-semibold text-[16px] text-center bg-white border-b border-[#CCCCCC] px-[18px] md:px-0 [&>span]:text-[16px] [&>p]:text-[16px] [&>p]:leading-6 [&>p]:font-semibold [&>span]:font-semibold [&>p]:text-[#090909] text-[#090909] [&>p]:px-1 [&>p]:!text-center mx-1 capitalize w-[25%]'>No. of items</Table.Cell>
                        <Table.Cell className='font-semibold text-[16px] text-center bg-white border-b border-[#CCCCCC] px-[18px] md:px-0 [&>span]:text-[16px] [&>p]:text-[16px] [&>p]:leading-6 [&>p]:font-semibold [&>span]:font-semibold [&>p]:text-[#090909] text-[#090909] [&>p]:px-1 [&>p]:!text-center mx-1 capitalize w-[25%]'>Ordered Date</Table.Cell>
                        <Table.Cell className='font-semibold text-[16px] text-center bg-white border-b border-[#CCCCCC] px-[18px] md:px-0 [&>span]:text-[16px] [&>p]:text-[16px] [&>p]:leading-6 [&>p]:font-semibold [&>span]:font-semibold [&>p]:text-[#090909] text-[#090909] [&>p]:px-1 [&>p]:!text-center mx-1 capitalize w-[25%]'>Total (incl. GST)</Table.Cell>
                    </Table.Head>
                    <Table.Body>
                        {details?.items?.map((item: any) => {
                            return (
                                <Table.Row >
                                    <Table.Cell className="orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 text-left">
                                        <div onClick={() => handleNavigate(item?.saleId ? item?.saleId : item?.ctOrderNumber, item?.saleId?false:true)} className={`cursor-pointer underline w-fit`}>
                                            {item?.saleId ? item?.saleId : `${item?.ctOrderNumber}`}
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell className="orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 !text-center">
                                        <div className={`w-fit mx-auto`} >
                                            {item?.numberOfItems ?? "-"}
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell className="orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 !text-center">
                                        {item?.orderDate.replace(/-/g, "/") ?? ''}
                                    </Table.Cell>
                                    <Table.Cell className="orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 !text-center">
                                        { item?.totalAmount?.displayAmount ?? '-'}
                                    </Table.Cell>

                                </Table.Row>
                            )
                        })}
                    </Table.Body>
                </Table.Container>
            </Table>
            <Pagination
                itemsPerPage={details?.pagination?.pageSize}
                totalItems={details?.pagination?.totalItems}
                paginate={paginate}
                currentPage={currentPage}
            />
        </>
    );
};

export default ActiveOrdersTable;